import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'bevvi-pill-badge',
  imports: [NgStyle],
  templateUrl: './pill-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillBadge {
  public readonly label = input.required<string>();
  public readonly textColor = input('var(--bot-primary, #C93030)');
  public readonly fillColor = input('transparent');
  public readonly strokeColor = input('var(--bot-primary, #C93030)');

  protected readonly badgeStyles = computed(() => ({
    '--pill-text': this.textColor(),
    '--pill-bg': this.fillColor(),
    '--pill-border': this.strokeColor(),
  }));
}
